import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import '../../css/editor.css';

import ApiService from '../../../../services/api';

import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';

import Save from '../../../../media/save.png';
import Delete from '../../../../media/delete.png';
import Teacher from '../../../../media/teacher.png';

import Back from '../../../../media/back.png';

import QuillEditor from '../../../../services/quill_editor';
import TinyMCEEditor from '../../../../services/tinymce';

const EditTeacher = () => {
  const { slug } = useParams();

  const navigate = useNavigate();

  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    professional_qualification: '',
    about_me: '',
    img_profile: null,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchTeacher = async () => {
      try {
        const res = await ApiService.getTeacher(slug);

        setForm({
          first_name: res.first_name || '',
          last_name: res.last_name || '',
          professional_qualification:
            res.professional_qualification || '',
          about_me: res.about_me || '',
          img_profile: res.img_profile || null,
        });

      } catch (err) {
        console.error('Errore nel caricamento:', err);

        toast.error('Errore nel caricamento dei dati');

        navigate('/admin/insegnanti');
      }
    };

    fetchTeacher();

  }, [slug, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({
      ...prev,
      img_profile: e.target.files[0]
    }));
  };

  const validate = () => {
    const errs = {};

    if (!form.first_name.trim()) {
      errs.first_name = ["Nome obbligatorio", true];
    }

    if (!form.last_name.trim()) {
      errs.last_name = ["Cognome obbligatorio", true];
    }

    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      setSaving(true);

      await ApiService.updateTeacher(form, slug);

      toast.success('Insegnante aggiornato con successo!');

      navigate('/admin/insegnanti');

    } catch (err) {
      console.error(err);

      toast.error("Errore durante l'aggiornamento");

    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    confirmToast({
      message: `Sei sicuro di voler eliminare questo insegnante?`,
      type: "error",
      confirmText: "Elimina",

      onConfirm: async () => {
        try {
          setDeleting(true);

          await ApiService.deleteTeacher(slug);

          toast.success(`Insegnante eliminato con successo`);

          navigate('/admin/insegnanti');

        } catch (err) {
          toast.error("Errore durante l'eliminazione");

        } finally {
          setDeleting(false);
        }
      },
    });
  };

  return (
    <form
      className="editor-form"
      onSubmit={handleSubmit}
    >

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <h2>
          <img
            src={Teacher}
            alt=""
            className="section-image"
          />

          Modifica insegnante
        </h2>

        <button
          type="button"
          onClick={handleDelete}
          disabled={saving || deleting}
          style={{ backgroundColor: 'crimson' }}
        >
          <img
            src={Delete}
            alt="Elimina"
            className="button-image2"
          />

          {deleting
            ? 'Eliminazione in corso...'
            : 'Elimina'}
        </button>
      </div>

      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/insegnanti`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco degli insegnanti
      </button>

      <label>Nome *</label>

      <input
        type="text"
        name="first_name"
        value={form.first_name}
        onChange={handleChange}
        className={`input ${errors.first_name ? "error" : ""}`}
        maxLength={250}
      />

      {errors.first_name && (
        <span className='error'>
          {errors.first_name}
        </span>
      )}

      <label>Cognome *</label>

      <input
        type="text"
        name="last_name"
        value={form.last_name}
        onChange={handleChange}
        className={`input ${errors.last_name ? "error" : ""}`}
        maxLength={250}
      />

      {errors.last_name && (
        <span className='error'>
          {errors.last_name}
        </span>
      )}

      <label>Qualifica professionale</label>

      <input
        type="text"
        name="professional_qualification"
        value={form.professional_qualification}
        onChange={handleChange}
        maxLength={250}
      />

      <label>
        Informazioni aggiuntive insegnante
      </label>

      <TinyMCEEditor
        value={form.about_me}
        onChange={(content) =>
          setForm((prev) => ({
            ...prev,
            about_me: content
          }))
        }
        placeholder="Scrivi eventuali informazioni aggiuntive utili"
      />

      <div className='attachstyle'>

        <label
          style={{
            display: "inline-block",
            padding: "10px 16px",
            background: "#393939",
            color: "white",
            borderRadius: "8px",
            cursor: "pointer",
            marginTop: "0"
          }}
        >
          + Immagine profilo

          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </label>

        {form.img_profile && (
          <div
            className='attachstyle2'
            style={{ padding: "20px" }}
          >
            <img
              src={
                typeof form.img_profile === "string"
                  ? form.img_profile
                  : URL.createObjectURL(form.img_profile)
              }
              alt="preview"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "16px",
                marginRight: "10px",
                objectFit:'cover'
              }}
            />

            <span>
              {typeof form.img_profile === "string"
                ? form.img_profile.split("/").pop()
                : form.img_profile.name}
            </span>
          </div>
        )}
      </div>

      <button
        type="submit"
        disabled={saving || deleting}
        style={{
          backgroundColor: '#2ecc71',
          marginTop: "50px"
        }}
      >
        <img
          src={Save}
          alt="Salva"
          className="button-image2"
        />

        {saving
          ? 'Salvataggio in corso...'
          : 'Salva'}
      </button>

    </form>
  );
};

export default EditTeacher;